<template>
    <div class="container-fluid px-lg-2 px-xl-4">
        <!-- Termina Encabezado de ubicación (Breadcum) -->
		<div class="row bg-white p-1 mt-2">
			<div class="col-12 col-md-11">
				<button @click="mostrarBusquedaAvanzada" class="btn btn-link" type="button">
					<i class></i>Salir de la búsqueda avanzada
				</button>
			</div>
			<div class="col-12 col-md-1 d-flex align-items-center justify-content-center">
				<a
					@click="vistaTarjetas(true)"
					class="type-list text-decoration-none cursor-pointer"
					role="button"
					v-bind:class="{active: !modoGrid}"
					v-show="!modoGrid"
				>
					<div class="d-none d-flex flex-column align-items-center font-12">
						<i class="icon-grupo-4354 fa-lg"></i>
						<span class="font-13">Galería</span>
					</div>
				</a>
				<a
					@click="vistaTarjetas(false)"
					class="type-list text-decoration-none cursor-pointer"
					role="button"
					v-bind:class="{active: modoGrid}"
					v-show="modoGrid"
				>
					<div class="d-none d-flex flex-column align-items-center">
						<i class="icon-grupo-4356 fa-lg"></i>
						<span class="font-13">Listado</span>
					</div>
				</a>
			</div>
		</div>

        <!-- Busqueda avanzada -->
		<div class="row pt-3">
			<div class="col-12">
				<div class="row py-2">
					<div class="col-md-6 ml-0 pl-0">
						<p class="titulo-busqueda">1. Busca el génerico:</p>
						<div class="input-group input-group-sm d-md-flex ml-3">
							<div class="input-group-prepend border-right-3">
								<span class="input-group-text bg-white" id="basic-addon1">
									<i class="icon-grupo-4423 border-right-0"></i>
								</span>
							</div>
							<input
								@keyup.enter="paso2()"
								aria-describedby="basic-addon1"
								aria-label="Search"
								class="form-control form-control-sm border-left-0"
								id="buscador"
								placeholder="Ej. Ibuprofeno"
								ref="paso1"
								type="search"
								v-model="avanzada.generico"
								@keydown="soloLetras"
							/>
							<div class="input-group-append">
								<button @click="paso2()" class="btn btn-blue" id="button-addon2" type="button">Siguiente</button>
							</div>
						</div>
					</div>
				</div>
				<div class="row py-2" v-show="avanzada.paso > 1">
					<div class="col-md-6 ml-0 pl-0">
						<p class="titulo-busqueda">2. ¿Cómo lo necesitas?</p>
						<div class="row">
							<div class="col-md-4 my-1">
								<button
									:class="[busqueda.parametros.tipoFormula=='S' ? 'active': '']"
									@click="paso3('S')"
									@keyup.right="$refs.paso2_2.focus()"
									class="btn btn-sm btn-light btn-block ml-3"
									ref="paso2_1"
								>Sólo</button>
							</div>
							<div class="col-md-4 my-1">
								<button
									:class="[busqueda.parametros.tipoFormula=='C' ? 'active': '']"
									@click="paso3('C')"
									@keyup.left="$refs.paso2_1.focus()"
									class="btn btn-sm btn-light btn-block ml-3"
									ref="paso2_2"
								>Combinado</button>
							</div>
						</div>
					</div>
				</div>
				<div class="row py-2" v-show="avanzada.paso > 2">
					<div class="col-12 ml-0 pl-0">
						<p class="titulo-busqueda">3. Forma farmacéutica:</p>
						<div class="d-flex flex-wrap">
							<div
								:key="index"
								class="img-forma-farma"
								v-for="(item, index) in avanzada.formasFarmaceuticas"
							>							
								<a @click="paso4(item.codFormaFarmaceutica)" role="button">
									<img
										:alt="item.descripcion"
										:id="'formafarna_' + index"
										:src="getImagenFormaFarmaceutica(item.descripcion, busqueda.parametros.codFormaFarmaceutica == item.codFormaFarmaceutica ? 1 : 0 )"
									/>
								</a>
								<b-tooltip
									:target="'formafarna_' + index"
									custom-class="ff-tooltip"
									placement="bottom"
								>{{item.descripcion}}</b-tooltip>
							</div>
						</div>
					</div>
				</div>
				<div class="row py-2" v-show="avanzada.paso > 3">
					<p class="titulo-busqueda">4. Selecciona una concentración</p>
					<select @change="paso5" class="form-control" v-model="busqueda.parametros.codFormula">
						<option value="0">Selecciona una concentración</option>
						<option
							:key="index"
							:value="item.codFormula"
							v-for="(item,index) in avanzada.formulas"
						>{{ item.descripcion }}</option>
					</select>
				</div>
				<div class="row py-2" v-show="avanzada.paso > 4">
					<p class="titulo-busqueda">5. Selecciona una presentación:</p>
					<div class="col-12">
						<div class="d-flex">
							<button
								:class="[busqueda.parametros.contenidoVenta==item.presentacion ? 'active': '']"
								:key="index"
								@click="paso6(item.presentacion)"
								class="btn btn-light mx-2"
								v-for="(item, index) in avanzada.contenidoVenta"
							>{{item.presentacion}}</button>
							<button
								:class="[busqueda.parametros.contenidoVenta == 0 ? 'active': '']"
								@click="paso6(0)"
								class="btn btn-light mx-2"
							>Todas</button>
						</div>
					</div>
				</div>
				<div class="row titulo-busqueda mt-2" v-show="mostrarResultados">
                    <div class="col">Resultados</div>
                </div>
			</div>
		</div>
		<!-- Termina busqueda avanzada -->

        <!-- tarjetas de productos -->
		<div v-show="mostrarResultados">
			<div
				:class="[modoGrid ? '' : 'row']"
				class="grid mt-2 d-none d-md-block"
				horizontal-order="true"
				item-selector=".grid-item"
				transition-duration=".8s"
				v-masonry
			>
				<div
					:class="[modoGrid ? '' : 'col-12 col-xl-6 p-0']"
					:key="index"
					class="grid-item"
					v-for="(item, index) in busqueda.resultados.resultados"
					v-masonry-tile
				>
					<pm-card-producto
						:class="{'ml-xl-1': modoGrid ? true : index%2 != 0, 'mr-xl-1':  modoGrid ? true : index%2 == 0}"
						:item="item"
						:key="index"
						:modoTarjeta="modoGrid"
						@agregarCantidad="agregarCantidad"
						@mostrarDetalle="mostrarDetalle"
						class="my-1"
					></pm-card-producto>
				</div>
			</div>

			<div class="mt-2 d-md-none d-flex flex-wrap justify-content-center">
				<div :key="index" v-for="(item, index) in busqueda.resultados.resultados">
					<pm-card-producto
						:item="item"
						:key="index"
						:modoTarjeta="true"
						@agregarCantidad="agregarCantidad"
						@mostrarDetalle="mostrarDetalle"
						class="mx-2 my-1"
					></pm-card-producto>
				</div>
			</div>

			<!-- Termina tarjetas de productos -->

			<!-- paginador -->
			<div class="row">
				<div class="col-12 pt-3 d-flex justify-content-center">
					<ul class="pagination">
						<li class="page-item" v-show="busqueda.resultados.pagina > 1">
							<a @click="navegar(1)" class="page-link" role="button">«</a>
						</li>
						<li class="page-item">
							<a
								@click="navegar(busqueda.parametros.pagina-1)"
								class="page-link text-decoration-none"
								role="button"
								v-show="busqueda.resultados.pagina > 1 && busqueda.resultados.resultados != null"
							>Anterior</a>
						</li>
						<li :class="{active: busqueda.resultados.pagina == pag}" :key="pag" class="page-item" v-for="pag in paginas">
							<a @click="navegar(pag)" class="page-link">{{pag}}</a>
						</li>
						<li class="page-item" v-show="busqueda.resultados.pagina < busqueda.resultados.totalPaginas">
							<a @click="navegar(busqueda.parametros.pagina+1)" class="page-link" role="button">Siguiente</a>
						</li>
						<li class="page-item" v-show="busqueda.resultados.pagina < busqueda.resultados.totalPaginas">
							<a @click="navegar(busqueda.resultados.totalPaginas)" class="page-link" role="button">»</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import servicio from "@/services/servicio-catalogo-general"
import PmCardProducto from "@/components/clientes/CardProducto"
import serviciodetalle from "@/services/servicio-detalle-producto"


export default {
    components: {
        PmCardProducto,
    },
    data(){
        return {
            avanzada: this.newAvanzada(),
            listadoTipoGaleria: true,
            modoGrid: false, 
			UUIDAcceso: '',
        }
    },
    updated(){            
        this.$nextTick(()=>{
            this.$redrawVueMasonry();
        })
    },
	mounted(){
		this.busqueda.parametros = this.$route.query

		let paso = this.$route.query.paso
		//let generico = this.$route.query.generico
		//let tipoFormula = this.$route.query.tipoFormula
		this.avanzada.generico = this.$route.query.generico
		this.avanzada.paso = this.$route.query.paso
		this.avanzada.tipoFormula = this.$route.query.tipoFormula
		this.busqueda.parametros.tipoFormula = this.$route.query.tipoFormula
		
		if(paso == 2 && this.avanzada.generico != "")
		{
			this.$nextTick(() => {
				this.$refs.paso2_1.focus()
			})
		}
		if(paso > 2){ // cargar formas farmaceuticas		
			servicio
				.buscarFormasFarmaceuticas({
					generico: this.avanzada.generico,
					tipoFormula: this.avanzada.tipoFormula,
				})
				.then((r) => {
					this.avanzada.formasFarmaceuticas = r.data
				})
				.catch((e) => {
					console.log(e)
				})
		}

		if(paso > 3){
			servicio
                .buscarFormulas({
                    generico: this.avanzada.generico,
                    tipoFormula: this.avanzada.tipoFormula,
                    codFormaFarmaceutica: this.$route.query.codFormaFarmaceutica,
                })
                .then((r) => {
                    this.avanzada.formulas = r.data
                })
                .catch((e) => {
                    console.log(e)
                })
		}

		if(paso > 4){
			servicio
                .buscarContenidoVenta({
                    generico: this.avanzada.generico,
                    tipoFormula: this.avanzada.tipoFormula,
                    codFormaFarmaceutica: this.busqueda.parametros.codFormaFarmaceutica,
                    codFormula: this.busqueda.parametros.codFormula,
				})
				.then((r) => {
					this.avanzada.contenidoVenta = r.data
				})
				.catch((e) => {
					console.log(e)
				})
            
		}

		if(paso > 3){
			this.buscarProductos()
		}
	},
    computed:{
        ...mapState(['busqueda']),
        mostrarResultados() {
            if (this.busqueda.parametros.busquedaAvanzada && this.avanzada.paso < 4) return false

            return true
        },			
        paginas() {                
            const pagina = Number(this.busqueda.resultados.pagina)
            const totPaginas = Number(this.busqueda.resultados.totalPaginas)

            if (pagina == null || totPaginas == null) return []

            let res = []
            const max = 5
            let aux = Math.floor(max / 2)

            let inicio = pagina - aux > 0 ? pagina - aux : 1

            let fin = pagina + aux > totPaginas ? totPaginas : pagina + aux

            for (let i = inicio; i <= fin; i++) {
                res.push(i)
            }

            return res
        },

    },    
    methods:{
		...mapActions(['buscarProductos', 'resetParametros', 'resetResultados']),
		updateQuery(){			
			let query = { 
				...this.busqueda.parametros,
				busquedaAvanzada:true,
				generico: this.avanzada.generico,
				tipoFormula: this.avanzada.tipoFormula,
				paso: this.avanzada.paso,
			}			

			this.$router.replace({
				query : query
			})
		},
		scrollToTop() {
			window.scrollTo(0, 0);
		},
        newAvanzada(){
            return {
                generico: "",
                tipoFormula: "A",
                paso: 1,
                formasFarmaceuticas: [],
                formulas: [],
                contenidoVenta: []
            }
		},
		mostrarBusquedaAvanzada(){
			this.resetParametros()
			this.$router.push({
				name: 'busqueda-general',
				query: this.busqueda.parametros
			})

		},
        getImagenFormaFarmaceutica(imagen, seleccionado) {
            let imagenes = ''
            if(seleccionado == 1){					
                imagenes = require.context("@/assets/img-priv/ff", false)
            }
            else{					
                imagenes = require.context("@/assets/img-priv/ff/grises", false)
			}			
			
			try{
				return imagenes("./" + imagen.toLowerCase() + ".png")
			}
			catch{
				return imagenes("./47.png")
			}
        },
        async agregarCantidad(item) {
			if(item.tipoControl == 1 && item.cantidad > 0){
				this.$msg.info( 'Producto refrigerado sin derecho a devolución.')
			}			
			if(item.precioRemate > 0 && item.cantidad > 0){
				this.$msg.info( 'Producto de remate sin derecho a devolución.')
			}
			let token = ''
			if(window.localStorage.tokenDifarmer)
			{
				let lstoken = JSON.parse(window.localStorage.tokenDifarmer)
				token = lstoken.token;
			}

			await this.validarClickPublicidad(item.codArticulo, token)

            this.carritoModificarCantidad(item.codArticulo, item.cantidad,this.UUIDAcceso)
        },
		async validarClickPublicidad(codArticulo, token){
			let r = await serviciodetalle.validarClickPublicidad({"idProducto":codArticulo, "accessToken":token} )
			if (r.data){
				this.UUIDAcceso = r.data[0]
			}
		},
        mostrarDetalle(codArticulo) {
            this.$router.push({
                path: `/clientes/detalle-producto/${codArticulo}`,
            })
        },
        paso1() {
			var campoBusquedad = this.avanzada.generico.trim();
			if(campoBusquedad == "")
			{
				this.$nextTick(() => {
					this.$refs.paso1.focus()
				})
				this.avanzada.generico = ""
			}
			this.newAvanzada()
			this.resetResultados()
        },
        paso2() {
			var campoBusquedad = this.avanzada.generico.trim();
			if(campoBusquedad == "")
			{
				this.paso1()
			}
			else
			{
				this.avanzada.paso = 2
				this.$nextTick(() => {
					this.$refs.paso2_1.focus()
				})
				this.resetResultados()
				this.updateQuery()
			}
        },
        paso3(tipoFormula) {
			var campoBusquedad = this.avanzada.generico.trim()
			if(campoBusquedad == "")
			{
				this.paso1()
			}
			else
			{
				this.$loading(true)
				
				this.avanzada.paso = 2

				this.avanzada.tipoFormula = tipoFormula
				this.busqueda.parametros.tipoFormula = tipoFormula
				
				this.busqueda.parametros.codFormula = 0
				this.busqueda.parametros.contenidoVenta = 0
				this.busqueda.parametros.pagina = 1
				this.busqueda.parametros.codFormaFarmaceutica = 0

				servicio
					.buscarFormasFarmaceuticas({
						generico: this.avanzada.generico.trim(),
						tipoFormula: this.avanzada.tipoFormula,
					})
					.then((r) => {
						this.avanzada.formasFarmaceuticas = r.data
						this.$loading(false)
						this.avanzada.paso = 3
						this.resetResultados()
						this.updateQuery()
					})
					.catch((e) => {
						console.log(e)
					})
			}
            
        },
        paso4(codFormaFarmaceutica) { 
			var campoBusquedad = this.avanzada.generico.trim();
			if(campoBusquedad == "")
			{
				this.paso1()
			}
			else
			{

				this.avanzada.codFormaFarmaceutica = codFormaFarmaceutica

				this.avanzada.paso = 3
				this.busqueda.parametros.pagina = 1
				this.busqueda.parametros.buscar = this.avanzada.generico.trim()
				this.busqueda.parametros.codFormaFarmaceutica = codFormaFarmaceutica
				this.busqueda.parametros.codFormula = 0
				this.busqueda.parametros.contenidoVenta = 0

				servicio
					.buscarFormulas({
						generico: this.avanzada.generico.trim(),
						tipoFormula: this.avanzada.tipoFormula,
						codFormaFarmaceutica,
					})
					.then((r) => {
						this.avanzada.formulas = r.data
						this.avanzada.paso = 4
						
						this.buscarProductos()
						this.updateQuery()
					})
					.catch((e) => {
						console.log(e)
					})
			}			
        },
        async paso5() {
            
            this.avanzada.paso = 5
            this.busqueda.parametros.pagina = 1
            this.busqueda.parametros.contenidoVenta = 0
            
            let r = await servicio
                .buscarContenidoVenta({
                    generico: this.avanzada.generico.trim(),
                    tipoFormula: this.avanzada.tipoFormula,
                    codFormaFarmaceutica: this.busqueda.parametros.codFormaFarmaceutica,
                    codFormula: this.busqueda.parametros.codFormula,
                })
            this.avanzada.contenidoVenta = r.data
            
			this.buscarProductos()
			this.updateQuery()
        },
        paso6(presentacion) {
            this.busqueda.parametros.contenidoVenta = presentacion
            this.busqueda.parametros.pagina = 1

			this.buscarProductos()
			this.updateQuery()
        },
        filtrarClasificacion() {				
            this.busqueda.parametros.pagina = 1
            this.$router.replace({
                query: this.busqueda.parametros
            }) 
            this.buscarProductos()
        },
        filtrarFormaFarmaceutica() {				
            this.busqueda.parametros.pagina = 1
            this.$router.replace({
                query: this.busqueda.parametros
            }) 
            this.buscarProductos()
        },
        vistaTarjetas(valor) {
            this.modoGrid = valor
            localStorage.setItem('modoGrid', valor)
            this.$nextTick(() => {
                if (typeof this.$redrawVueMasonry === "function") {
                    this.$redrawVueMasonry()
                }
            })
        },
        navegar(pag) {				
            this.busqueda.parametros.pagina = pag

            let query = {
                ...this.busqueda.parametros,
                generico: this.avanzada.generico,
                paso: this.avanzada.paso
            }
            this.$router.replace({
                query: query
            }) 
            this.buscarProductos()
			this.scrollToTop()
        },
		soloLetras(e) {
			
			if((event.keyCode < 65 || event.keyCode > 90) && event.keyCode !== 8 && event.keyCode !== 32 && event.keyCode !== 13) {
				e.preventDefault();
			}
		}
    }
}
</script>

<style>

</style>